import React, { Component } from 'react'
import { Button } from 'semantic-ui-react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as sessionActions from '../actions/sessionActions'

class LogOutButton extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }
    this.logOut = this.logOut.bind(this)
  }

  logOut (event) {
    event.preventDefault()
    this.props.actions.logOutUser()
  }

  render () {
    return (
      <Button className={'bg-ititoca yellow-ititoca'} onClick={this.logOut.bind(this)} color='black'>Deconnexion</Button>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch)
  }
}
export default connect(null, mapDispatchToProps)(LogOutButton)

export { LogOutButton }



// WEBPACK FOOTER //
// ./src/components/LogoutButton.js